var map = {
	"./construction_on_melody_lane.jpg": "cc03",
	"./enigmatic_synthesis.jpg": "dcfe",
	"./new_dawn.jpg": "2776",
	"./rise.jpg": "1b49",
	"./tenebristic_wonderland.jpg": "3f90"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a8fb";